module.exports = "<div class=\"detail-item\">\r\n    <h1 class=\"detail-item_brand header--color-secondary\">\r\n        <span itemprop=\"brand\" itemscope itemtype=\"http://schema.org/Brand\">\r\n            <span itemprop=\"name\">{{ productDetails.brand_name }}</span>\r\n        </span>\r\n        <div itemprop=\"name\" class=\"detail-item_title title--type-2 h2 header--color-secondary\">{{ productDetails.producttitle }}</div>\r\n    </h1>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/cards/detail/common/detail-item-template.html
 ** module id = 895
 ** module chunks = 1
 **/